import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import AcompanhamentoForm from './components/AcompanhamentoForm';

const CadastrosAcompanhamentosMain = () => {
  const routeSegments = [
    { name: 'Início', path: '/' },
    { name: 'Acompanhamentos', path: '/pages/acompanhamentos' },
    { name: 'Criar' },
  ];

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={routeSegments} />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <AcompanhamentoForm isReadOnly={false} hideHeader={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CadastrosAcompanhamentosMain;
